"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmptyFolder;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _emptyFolder = _interopRequireDefault(require("bender-url!FileManagerImages/images/empty-folder.svg"));

var _AddFolderButton = _interopRequireDefault(require("./AddFolderButton"));

function EmptyFolder(props) {
  var onCreateFolder = props.onCreateFolder,
      folders = props.folders,
      selectedFolder = props.selectedFolder,
      isReadOnly = props.isReadOnly;
  return _react.default.createElement("div", {
    className: "text-center",
    "data-test-id": "empty-folder"
  }, _react.default.createElement(_UIImage.default, {
    className: "m-y-10",
    width: 100,
    src: _emptyFolder.default,
    responsive: false
  }), _react.default.createElement("h5", null, _I18n.default.text('FileManagerLib.emptyFolder.message')), _react.default.createElement("p", null, !isReadOnly && _react.default.createElement(_FormattedReactMessage.default, {
    message: "FileManagerLib.emptyFolder.hint",
    options: {
      button: _react.default.createElement(_AddFolderButton.default, {
        folders: folders,
        selectedFolder: selectedFolder,
        onCreate: onCreateFolder,
        isReadOnly: isReadOnly
      }, _I18n.default.text('FileManagerLib.emptyFolder.inlineButtonText'))
    }
  })));
}

EmptyFolder.propTypes = {
  folders: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  selectedFolder: _propTypes.default.instanceOf(_immutable.default.Map),
  onCreateFolder: _propTypes.default.func.isRequired,
  isReadOnly: _propTypes.default.bool.isRequired
};
EmptyFolder.defaultProps = {
  isReadOnly: false
};
module.exports = exports.default;